import React from 'react';
import TaskChecklistIcon from '@/assets/icons/TaskChecklistIcon';
import CertificateIcon from '@/assets/icons/CertificateIcon';
import clsx from 'clsx';

const CompanyTags = ({ company, variant = 'default' }) => {
  const tagsIcons = {
    jobsCount: TaskChecklistIcon,
    // recommendations: RecommendIcon, //Todo: concept not implemented yet
    companyCertificates: CertificateIcon,
  };

  const ListItem = ({ name, index, children }) => (
    <li
      key={name}
      className={clsx([
        'flex items-center px-1.5 py-1 gap-2.5',
        variant === 'default' && index === 0 && 'bg-sidebar-accent',
        variant === 'default' && 'border border-sidebar-accent rounded-lg',
        variant === 'white' && 'bg-white rounded-[14px]',
      ])}
    >
      {children}
    </li>
  );

  const companyTags = {
    jobsCount: company.jobsCount && `${company.jobsCount} jobber`,
    // recommendations: `${company.recommendations} anbefalinger`, //Todo: concept not implemented yet
    companyCertificates:
      company.companyCertificates.length &&
      `${company.companyCertificates.length} sertifiseringer`,
    postalPlace: company.address.postalPlace && company.address.postalPlace,
  };

  return (
    <ul className="flex flex-wrap items-center gap-1.5">
      {company.industryAssociations.length > 0 &&
        company.industryAssociations.slice(0, 3).map((el, index) => (
          <ListItem name={el.name} index={index}>
            <p className="text-[10px] font-medium text-black">{el.name}</p>
          </ListItem>
        ))}
      {Object.keys(companyTags).map((el) => {
        const IconComponent = tagsIcons[el];
        if (companyTags[el]) {
          return (
            <ListItem name={el}>
              <>
                {variant === 'default' && IconComponent && <IconComponent />}
                <p className="text-[10px] font-medium text-black">
                  {companyTags[el]}
                </p>
              </>
            </ListItem>
          );
        }
        return null;
      })}
    </ul>
  );
};

export default CompanyTags;
